/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable no-continue */
/* eslint-disable no-unused-vars */
/* eslint-disable no-await-in-loop */
import { firestore as db } from "src/Firebase"

export const getAllFaces = (idconjunto, raspberryId, rostroId, observer) =>
  db
    .collection("conjuntos")
    .doc(idconjunto)
    .collection("rostros")
    .doc(rostroId)
    .collection("imagenes")
    .onSnapshot(observer)

export const getAllBiometricDevices = (idconjunto, observer) =>
  db
    .collection("conjuntos")
    .doc(idconjunto)
    .collection("rostros")
    .onSnapshot(observer)

export const getBiometricDevice = (idconjunto, rostroId) =>
  db
    .collection("conjuntos")
    .doc(idconjunto)
    .collection("rostros")
    .doc(rostroId)
    .get()

export const getDeviceImages = (idconjunto, rostroId, observer) =>
  db
    .collection("conjuntos")
    .doc(idconjunto)
    .collection("rostros")
    .doc(rostroId)
    .collection("imagenes")
    .onSnapshot(observer)

export const getImportJob = (conjuntoId, jobId, observer) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("import_jobs")
    .doc(jobId)
    .onSnapshot(observer)

export const getActiveImportJobs = (conjuntoId, observer) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("import_jobs")
    .where("status", "in", ["processing", "pending"])
    .orderBy("created_at", "desc")
    .onSnapshot(observer)

export const getImportJobHistory = (conjuntoId, observer) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("import_jobs")
    .orderBy("created_at", "desc")
    .limit(20)
    .onSnapshot(observer)

export const getDeviceImagesOnce = (conjuntoId, dispositivoId) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("rostros")
    .doc(dispositivoId)
    .collection("imagenes")
    .get()
    .then(snapshot => snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })))

export const migrateRostrosFirebase = async (
  conjuntoId,
  sourceDeviceId,
  targetDeviceId,
  onProgress = () => {}
) => {
  const successful = []
  const failed = []
  const skipped = []
  const sourceImages = await getDeviceImagesOnce(conjuntoId, sourceDeviceId)

  if (sourceImages.length === 0) {
    return { successful, failed, skipped, total: 0 }
  }

  const targetImages = await getDeviceImagesOnce(conjuntoId, targetDeviceId)
  const existingIds = new Set(
    targetImages.map(img => img.identificacion).filter(Boolean)
  )

  const targetRef = db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("rostros")
    .doc(targetDeviceId)
    .collection("imagenes")

  const total = sourceImages.length

  for (let i = 0; i < sourceImages.length; i++) {
    const rostro = sourceImages[i]

    if (existingIds.has(rostro.identificacion)) {
      skipped.push({ ...rostro, razon: "Ya existe en dispositivo destino" })
      onProgress(i + 1, total)
      continue
    }

    try {
      const { id, ...data } = rostro
      const nuevoDoc = {
        ...data,
        dispositivo_id: targetDeviceId,
        is_sync: false,
        is_sync_blocked: (data.estado || "activo").toLowerCase() !== "activo",
        fecha_actualizacion: new Date(),
      }

      await targetRef.add(nuevoDoc)
      successful.push(rostro)
    } catch (err) {
      failed.push({
        ...rostro,
        error: err?.message || "Error al escribir en Firestore",
      })
    }

    onProgress(i + 1, total)
  }

  return { successful, failed, skipped, total }
}
